import clsx from "clsx"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import Button from "../../../../ui/molecules/button"
import '../style.scss'
import { PopupForm } from "../../../../ui/organisms/popupForm"
import { TrashIcon } from "../../../../ui/icons/trash"
import { Alert } from "../../../../ui/organisms/alert"
import { useState } from "react"
import { SelectCustom } from "../../../../ui/molecules/select"
import { OptionType } from "../../../../utils"

export function MembriOrganoCollegiale() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const sessionState = useAppSelector(state => state.session)
    const [showPopupMembri, setShowPopupMembri] = useState<boolean>(false);
    const [showAlertDelete, setShowAlertDelete] = useState<boolean>(false)

    const membriColleg = [
        {
            id: '1',
            name: 'Alfio Tirendi',
            office: 'UCO',
            date: '10/11/2025',
            place: 'Scordia (CT)'
        },
        {
            id: '1',
            name: 'Alfio Trenta',
            office: 'UCE',
            date: '10/11/2025',
            place: 'Scordia (CT)'
        },
        {
            id: '1',
            name: 'Alfio Maggio',
            date: '10/11/2025',
            office: 'UCO',
            place: 'Scordia (CT)'
        },
    ]

    const membriCollegOptions: OptionType[] = [
        { value: 'Alfio Trenta', label: 'Alfio Trenta' },
        { value: 'Alfio Maggio', label: 'Alfio Maggio' },
        { value: 'Alfio Tirendi', label: 'Alfio Tirendi' }
    ]


    return (
        <div>
            <h3 className="sectionTitle text-left">Lista Membri Organo Collegiale di delibera</h3>
            <table id="list-table" className="w-[40%]">
                <tr>
                    <th>Operazioni</th>
                    <th onClick={() => setShowPopupMembri(true)}>Nominativo</th>
                    <th >Funzione</th>
                    <th>Data</th>
                    <th>Luogo</th>
                </tr>
                <tbody>
                    {membriColleg.map((membro, index) =>
                        <tr
                            key={index}
                            style={{
                                color: '#4D797F',
                                background: index % 2 === 0 ? '#F2F7F7' : '#FFFFFF'
                            }}
                        >
                            <td>
                                <button onClick={() => { setShowAlertDelete(true) }} className="tooltip-container">
                                    <TrashIcon color={"red"} size={20} />
                                    <span className="tooltip-text">Elimina</span>
                                </button>
                            </td>
                            <td>{membro.name}</td>
                            <td>{membro.office}</td>
                            <td>{membro.date}</td>
                            <td>{membro.place}</td>
                        </tr>
                    )}
                </tbody>
            </table>
            {
                showPopupMembri &&
                <PopupForm headerGreen={true} title={'Aggiungi Membro'} close={() => setShowPopupMembri(false)}>
                    <div className=" p-6" style={{ display: "flex", flexDirection: 'column', justifyContent: 'center' }}>
                        <div className="pb-3 mt-6 ">
                            <div>
                                <SelectCustom
                                    label="Membri"
                                    placeholder="membri"
                                    options={membriCollegOptions}
                                    onChange={() => console.log()}
                                />
                            </div>

                        </div>
                        <div className="pb-3 mt-6">
                            <div>
                                <SelectCustom
                                    label="Membri"
                                    placeholder="membri"
                                    options={membriCollegOptions}
                                    onChange={() => console.log()}
                                />
                            </div>

                        </div>
                        <div className="mt-6" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Button
                                variant="outline"
                                color="dimgrey"
                                iconPosition="off"
                                label="Annulla"
                                size="md"
                                onClick={() => setShowAlertDelete(false)}
                            />
                            <div className="pl-8">
                                <Button
                                    variant="solid"
                                    color="orange"
                                    iconPosition="off"
                                    label="Elimina"
                                    size="md"
                                    onClick={() => console.log()}
                                />
                            </div>
                        </div>

                    </div>
                </PopupForm>
            }
            {
                (showAlertDelete) && (
                    <Alert title="Conferma Eliminazione" close={() => setShowAlertDelete(false)} headerGreen={true}>
                        <div style={{ display: "flex", flexDirection: 'column', justifyContent: 'center' }}>
                            <div className="pb-3 mt-6">
                                <div>
                                    Sei sicuro di voler <b>eliminare</b> questo membro?
                                </div>

                            </div>
                            <div className="mt-6" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Button
                                    variant="outline"
                                    color="dimgrey"
                                    iconPosition="off"
                                    label="Annulla"
                                    size="md"
                                    onClick={() => setShowAlertDelete(false)}
                                />
                                <div className="pl-8">
                                    <Button
                                        variant="solid"
                                        color="orange"
                                        iconPosition="off"
                                        label="Elimina"
                                        size="md"
                                        onClick={() => console.log()}
                                    />
                                </div>
                            </div>

                        </div>
                    </Alert>
                )
            }
        </div>
    )

}